import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { UserInlinePreview, UserInlinePreviewList } from '@atlassian/user-inline-preview';

import type { Collaborator } from '../../types';

/** Matches product spec: at most eight collaborators, no expansion control. */
export const USER_PROFILE_PREVIEW_COLLABORATORS_MAX = 8;
export const USER_PROFILE_PREVIEW_COLLABORATORS_MAX_COMPACT = 3;

const styles = cssMap({
	rowDividerCompact: {
		borderBlockStart: `${token('border.width')} solid ${token('color.border')}`,
	},
});

interface CollaboratorsProps {
	collaborators: Collaborator[];
	cloudId: string;
	orgId?: string;
	testId?: string;
	variant?: 'compact' | 'full';
}

export function Collaborators({
	collaborators,
	cloudId,
	orgId,
	testId = 'user-profile-preview-collaborators',
	variant = 'full',
}: CollaboratorsProps): React.JSX.Element {
	const isCompact = variant === 'compact';
	return (
		<UserInlinePreviewList
			layout={isCompact ? 'stack' : 'grid'}
			gap={isCompact ? 'none' : 'space.100'}
			maxVisibleItems={
				isCompact
					? USER_PROFILE_PREVIEW_COLLABORATORS_MAX_COMPACT
					: USER_PROFILE_PREVIEW_COLLABORATORS_MAX
			}
			testId={testId}
		>
			{collaborators.map((person, index) => (
				<Box key={person.accountId} xcss={isCompact && index > 0 && styles.rowDividerCompact}>
					<UserInlinePreview
						data={{
							accountId: person.accountId,
							name: person.name,
							avatarUrl: person.avatarUrl,
							jobTitle: person.jobTitle,
						}}
						cloudId={cloudId}
						orgId={orgId}
						showOrgChartButton={false}
						renderContext="collaborator"
						background={isCompact ? 'surface' : 'sunken'}
					/>
				</Box>
			))}
		</UserInlinePreviewList>
	);
}
